import React, { Component } from 'react';
//import '@styles/adm/shared/deleteButton.scss'; 
import { Button } from '@components/shared/Button';

export class DeleteButton extends Component {
    static displayName = DeleteButton.name;

    constructor(props) {
        super(props);
        this.state = {
            showConfirmation: false
        }
    }

    HandleToggleConfirmation = () => {
        this.setState((prevState) => ({
            ...prevState,
            showConfirmation: !this.state.showConfirmation
        }));
    }

    render() {

        return (
            <div className='d-flex'>
                <Button className='col-2' small={this.props.small === true} text={this.state.showConfirmation ? 'Zrušit' : 'Smazat'} OnClick={() => this.HandleToggleConfirmation()} disabled={this.props.disabled === true} />
                {this.state.showConfirmation &&
                    <div className='ms-1'><Button className='col-2 m-5' text={'Opravdu smazat'} OnClick={() => this.props.OnDelete()} /></div>
                }
            </div>
        );
    }
}
